import React, { useState, useEffect } from 'react';

export default function RateManager({ api }) {
  const [processPaths, setProcessPaths] = useState([]);
  const [file, setFile] = useState(null);
  const [uploadMsg, setUploadMsg] = useState('');

  const loadData = () => {
    fetch(`${api}/api/process-paths`).then(r => r.json()).then(setProcessPaths);
  };
  useEffect(() => { loadData(); }, [api]);

  const updateCPLH = async (id, value) => {
    await fetch(`${api}/api/process-paths/${id}/cplh`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ baseline_cplh: parseFloat(value) || 0 })
    });
  };

  const uploadCSV = async (e) => {
    e.preventDefault();
    if (!file) return;
    const fd = new FormData();
    fd.append('file', file);
    const res = await fetch(`${api}/api/rates/upload`, { method: 'POST', body: fd });
    const data = await res.json();
    if (data.success) { setUploadMsg(`Updated ${data.count} rates.`); loadData(); setTimeout(() => setUploadMsg(''), 3000); }
    else setUploadMsg(`Error: ${data.error}`);
  };

  const grouped = processPaths.reduce((acc, pp) => {
    (acc[pp.department_name] = acc[pp.department_name] || []).push(pp);
    return acc;
  }, {});

  return (
    <div>
      <h2 className="section-title">Manage Baseline CPLH Rates</h2>
      <div className="card">
        <h3 className="section-title">Upload Rates (CSV)</h3>
        <p style={{ fontSize: '0.85rem', color: '#666', marginBottom: 12 }}>CSV columns: "Process Path" and "CPLH"</p>
        <form onSubmit={uploadCSV} style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
          <input type="file" accept=".csv" onChange={e => setFile(e.target.files[0])} />
          <button type="submit" className="btn btn-primary">Upload</button>
        </form>
        {uploadMsg && <div className="success-msg" style={{ marginTop: 12 }}>{uploadMsg}</div>}
      </div>
      <div className="card">
        <h3 className="section-title">Edit Baseline CPLH by Department</h3>
        {Object.entries(grouped).map(([dept, paths]) => (
          <div key={dept} style={{ marginBottom: 20 }}>
            <h4 style={{ fontSize: '0.9rem', color: '#232f3e', marginBottom: 8 }}>{dept}</h4>
            <table>
              <thead><tr><th>Process Path</th><th>Baseline CPLH</th></tr></thead>
              <tbody>
                {paths.map(pp => (
                  <tr key={pp.id}>
                    <td>{pp.name}</td>
                    <td><input type="number" min="0" step="0.1" defaultValue={pp.baseline_cplh}
                      onBlur={e => updateCPLH(pp.id, e.target.value)}
                      style={{ width: 100, padding: '4px 8px', border: '1px solid #ddd', borderRadius: 3 }} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>
      <div className="card">
        <h3 className="section-title">Upload Shift Plans (CSV)</h3>
        <p style={{ fontSize: '0.8rem', color: '#666', marginBottom: 8 }}>
          <a href="#" onClick={(e) => {
            e.preventDefault();
            const template = 'Code,Throughput,IB CPLH,OB CPLH,IB Hours,OB Hours,Total Hours,LP Cartons,PR Pallets,PR Density,Combined,AROS\n46190Day,48,63,44,400,600,1000,50000,200,27.5,50000,10000\n46190Night,48,63,44,350,500,850,40000,150,27.5,40000,8000';
            const blob = new Blob([template], { type: 'text/csv' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a'); a.href = url; a.download = 'shift_plan_template.csv'; a.click();
          }} style={{ color: '#232f3e', fontWeight: 600 }}>⬇ Download Template CSV</a>
        </p>
        <form onSubmit={async (e) => {
          e.preventDefault();
          const fileInput = e.target.querySelector('input[type="file"]');
          if (!fileInput.files[0]) { setUploadMsg('Please select a file'); return; }
          const fd = new FormData();
          fd.append('file', fileInput.files[0]);
          const res = await fetch(`${api}/api/shift-plans/upload`, { method: 'POST', body: fd });
          const data = await res.json();
          if (data.success) { setUploadMsg(`${data.plans_created} shift plan(s) created`); setTimeout(() => setUploadMsg(''), 5000); }
          else setUploadMsg(`Error: ${data.error}`);
        }}>
          <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
            <input type="file" accept=".csv" />
            <button type="submit" className="btn btn-primary">Upload Plans</button>
          </div>
        </form>
        {uploadMsg && <div className="success-msg" style={{ marginTop: 12 }}>{uploadMsg}</div>}
      </div>
    </div>
  );
}
